import React, {useEffect} from "react";
import {
    receiveData,
    setFilterCountry,
    setCurrentPage, 
    setFilteredTotalCount
} from "../store/actions"
import {connect} from "react-redux";
import CountriesDropDown from "./CountriesDropDown";
import ASPLocation from "./ASPLocation";
import Pagination from "../../Pagination/components/Pagination";
import {calculateSliceEndingPoint, calculateSliceStartingPoint} from "../../Pagination/helpers/calculations";

const ASPCentres = (props) => {
    
    useEffect(() => {
        props.receiveData(props.apiUrl);
        props.setCurrentPage(parseInt(props.paginationInitialPage));
    }, [])

    useEffect(() => {
        if (props.aspLocations.locations.length !== 0)
            props.setFilteredTotalCount(props.aspLocations.locations.filter(countriesFilter).length)

    }, [props.aspLocations.locations])
    
    useEffect(() => {
        props.setFilteredTotalCount(props.aspLocations.locations.filter(countriesFilter).length)
    }, [props.filterCountry])
    
    const countriesFilter = l => l.Country.toUpperCase().indexOf(props.filterCountry.toUpperCase()) >= 0;
    
    let aspLocations = props.aspLocations.locations;
    if (props.showCountryDropDown.toUpperCase() === "TRUE" && props.aspLocations.countries && props.aspLocations.countries.length > 1 && props.aspLocations.countries.length > 0){
        aspLocations = aspLocations.filter(countriesFilter);
    }
    if (props.showPagination.toUpperCase() === "TRUE"){
        aspLocations = aspLocations.slice(calculateSliceStartingPoint(props.paginationItemsPerPage, props.currentPage), calculateSliceEndingPoint(props.paginationItemsPerPage, props.currentPage, props.filteredTotalCount));
    }
    
    return (
        <div className="aspCentresContainer">
            {props.showCountryDropDown.toUpperCase() === "TRUE" && props.aspLocations.countries && props.aspLocations.countries.length > 1 && props.aspLocations.countries.length > 0 &&
                <div className="countriesDDWrap"> 
                    <label for="countriesDD" className="title">Filter by country:</label>
                    <CountriesDropDown
                        elmId="countriesDD"
                        countryItems={props.aspLocations.countries}
                        selectedCountry={props.filterCountry}
                        onCountryChange={(countryName) => {
                            props.setFilterCountry(countryName);
                            props.setCurrentPage(1);
                        }}>
                    </CountriesDropDown>
                </div>
            }
            
            <table className="standard-table spacedafter">
                <thead>
                    <tr>
                        <th>{i18njs["Forms.Country"]}</th>
                        <th>{i18njs["Forms.Company"]}</th>
                        <th>{i18njs["Resource.contact"]}</th>
                    </tr>
                </thead>
                <tbody>
                    {aspLocations.map((x) => {
                        return (
                            <ASPLocation key={x.id} location={x}></ASPLocation>
                        )
                    })}
                </tbody>
            </table>

            {props.showPagination.toUpperCase() === "TRUE" &&
                <div className="paginationWrap">
                    <Pagination
                        totalItemsCount={props.filteredTotalCount} 
                        itemsPerPage={props.paginationItemsPerPage} 
                        currentPage={props.currentPage}
                        onPageChange={(pageNumber) => {
                            props.setCurrentPage(pageNumber);
                            window.scrollTo(0, 0)
                        }}>
                    </Pagination>
                </div>
            }
        </div>
    )
}

const aspCentresToProps = (state) => {
    console.log(state)
    return {
        aspLocations: state.aspLocations,
        filterCountry: state.aspState.filterCountry,
        filteredTotalCount: state.aspState.filteredTotalCount,
        currentPage: state.aspState.currentPage
    }
}

const connectedASPCentres = connect(aspCentresToProps, {
    receiveData, setFilterCountry, setCurrentPage, setFilteredTotalCount
})(ASPCentres);

export default connectedASPCentres;